export default __webpack_public_path__ + "static/media/e1d790c68f543b39.7b9411e6ee846c475c8b9384dd18bff8.svg";